/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React, { useState } from 'react'
import clsx from 'clsx'
import UiInput, { UiInputProps } from 'components/Ui/UiInput'
import { useTranslation } from 'react-i18next'

interface UiPasswordInputProps extends Omit<UiInputProps, 'type' | 'endIcon' | 'endIconInteractive'> {}

const UiPasswordInput = React.forwardRef<HTMLInputElement, UiPasswordInputProps>(
    (props, ref) => {
        const { t } = useTranslation()
        const [visible, setVisible] = useState(false)

        return (
            <UiInput
                {...props}
                ref={ref}
                containerClassName="UiPasswordInput"
                type={visible ? 'text' : 'password'}
                endIconInteractive={true}
                endIcon={
                    <button
                        type="button"
                        onClick={() => setVisible((v) => !v)}
                        className={clsx(
                            'text-gray-500 hover:text-gray-700 focus:outline-none focus:border-primary-600 border border-transparent rounded p-1',
                            'dark:text-gray-400 dark:hover:text-gray-200'
                        )}
                        aria-label={`${t(visible ? 'Hide' : 'Show')} ${t('Password')}`}
                    >
                        <span className={clsx('text-xs uppercase tracking-wide')}>
                            {visible ? t('Hide') : t('Show')}
                        </span>
                    </button>
                }
            />
        )
    }
)

UiPasswordInput.displayName = 'UiPasswordInput'

export default UiPasswordInput
